import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { IPortalLink } from '@nha/api/core';
import * as fromActions from './portal-link.actions';
import { PortalLinkState } from './portal-link.state';

export const portalLinkAdapter: EntityAdapter<IPortalLink> = createEntityAdapter<IPortalLink>({
	selectId: (x) => x.portalLinkID
});

export const initialPortalLinkState: PortalLinkState = portalLinkAdapter.getInitialState({
	loaded: false,
	loading: false
});

export const portalLinkReducers = createReducer(
	initialPortalLinkState,

	on(fromActions.LoadPortalLinks, (state) => {
		return { ...state, loaded: false, loading: true };
	}),

	on(fromActions.SetPortalLinks, (state, { portalLinks }) => {
		return portalLinkAdapter.setAll(portalLinks, { ...state, loaded: true, loading: false });
	}),

	on(fromActions.SetFavorite, (state, { portalLinkID, isFavorite }) => {
		return portalLinkAdapter.updateOne({ id: portalLinkID, changes: { isFavorite: isFavorite, favoriteOrderNumber: 10000 } }, state);
	}),

	// Server confirms the toggle and returns the authoritative favorite order. Only apply
	// that order to the returned ids — do NOT reconcile isFavorite across every link.
	// A serialized response can lag behind rapid consecutive toggles, so reconciling here
	// would flip just-added favorites back off ("disappear/reappear" jitter). isFavorite is
	// owned by the optimistic SetFavorite update.
	on(fromActions.UpdateFavorites, (state, { portalLinkIDs }) => {
		return portalLinkAdapter.updateMany(
			portalLinkIDs.map((id, index) => ({ id, changes: { favoriteOrderNumber: index + 1 } })),
			state
		);
	})
);
